import { Badge } from '@/components/ui'
import { formatRelativeTime } from '@/utils'
import type { IntegrationOverviewEntry } from '@/types/integrationsOverview'

/** Health for one entry — the drawer's per-set view. Lives apart from
 *  chips.tsx so that file exports only components (react-refresh rule). */
export function entryHealthChip(entry: IntegrationOverviewEntry, probeAvailable: boolean) {
  if (!entry.last_tested_at) {
    return probeAvailable
      ? <Badge variant="secondary">Never tested</Badge>
      : <Badge variant="outline">No automated test</Badge>
  }
  if (entry.last_test_ok === false) {
    return <Badge variant="destructive">Failed: {entry.last_test_detail || 'unknown'}</Badge>
  }
  return (
    <Badge variant="success">
      Verified {formatRelativeTime(new Date(entry.last_tested_at).getTime())}
    </Badge>
  )
}
